import { SignedIn, SignedOut, SignInButton, UserButton } from "@clerk/nextjs";
import { Button } from "./ui/button";
import { UserPlus } from "lucide-react";

export default function SignInAndOut({ pathname }) {
  return (
    <div className="flex items-center justify-end h-14">
      <SignedOut>
        <SignInButton
          mode="modal"
          forceRedirectUrl={pathname}
          signUpForceRedirectUrl={pathname}
        >
          <Button
            variant="ghost"
            size="icon"
            className="rounded-xl text-slate-900/75 transition hover:bg-black/5 hover:text-slate-950 dark:text-white/75 dark:hover:bg-white/10 dark:hover:text-white"
          >
            <UserPlus />
          </Button>
        </SignInButton>
      </SignedOut>
      <SignedIn>
        <UserButton afterSignOutUrl={pathname} />
      </SignedIn>
    </div>
  );
}
